/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
 
function codetobeRepeated(){
    var cb2 = document.querySelector('#cb2');
    if(!cb2)return; 
    var upsellproductid = cb2.dataset.upsellproduct;
    var prodItem = document.querySelector('.cart__item[data-productid="'+upsellproductid+'"]'); 

    if(prodItem){
      document.querySelector('input#cb2').checked = true;
    }else{
      document.querySelector('input#cb2').checked = false;
    } 
}

function checktoggleFunction(){ 
   setTimeout(codetobeRepeated,4500);
}
function updateUpsellSelection(upsellproductid)
{
  setTimeout(function(){
    var prodItem = document.querySelector('.cart__item[data-productid="'+upsellproductid+'"]'); 
    if(document.querySelector('input#cb2').checked){
      if(!prodItem)
        document.querySelector('.cart__widget.cart__widget--products.custom_item_upsell quick-add-product button.product-upsell__btn').click();
    }else{
      if(prodItem)
        prodItem.querySelector('button.cart__quantity-minus').click();
    }
  },200);
}

